export var ConfirmationDelta;
(function (ConfirmationDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["CONFIRMATION_DELTA"] = "confirmation_delta";
    })(type = ConfirmationDelta.type || (ConfirmationDelta.type = {}));
})(ConfirmationDelta || (ConfirmationDelta = {}));
